var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessW(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.26406 14.6L16.3141 7.55L14.9141 6.15L9.26406 11.8L6.41406 8.95L5.01406 10.35L9.26406 14.6ZM10.6641 20C9.28073 20 7.98073 19.7375 6.76406 19.2125C5.5474 18.6875 4.48906 17.975 3.58906 17.075C2.68906 16.175 1.97656 15.1167 1.45156 13.9C0.926562 12.6833 0.664062 11.3833 0.664062 10C0.664062 8.61667 0.926562 7.31667 1.45156 6.1C1.97656 4.88333 2.68906 3.825 3.58906 2.925C4.48906 2.025 5.5474 1.3125 6.76406 0.7875C7.98073 0.2625 9.28073 0 10.6641 0C12.0474 0 13.3474 0.2625 14.5641 0.7875C15.7807 1.3125 16.8391 2.025 17.7391 2.925C18.6391 3.825 19.3516 4.88333 19.8766 6.1C20.4016 7.31667 20.6641 8.61667 20.6641 10C20.6641 11.3833 20.4016 12.6833 19.8766 13.9C19.3516 15.1167 18.6391 16.175 17.7391 17.075C16.8391 17.975 15.7807 18.6875 14.5641 19.2125C13.3474 19.7375 12.0474 20 10.6641 20ZM10.6641 18C12.8974 18 14.7891 17.225 16.3391 15.675C17.8891 14.125 18.6641 12.2333 18.6641 10C18.6641 7.76667 17.8891 5.875 16.3391 4.325C14.7891 2.775 12.8974 2 10.6641 2C8.43073 2 6.53906 2.775 4.98906 4.325C3.43906 5.875 2.66406 7.76667 2.66406 10C2.66406 12.2333 3.43906 14.125 4.98906 15.675C6.53906 17.225 8.43073 18 10.6641 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessW);
export default __webpack_public_path__ + "static/media/success_w.168169a48a9763d0e0c43352477a8bce.svg";
export { ForwardRef as ReactComponent };